module.exports = __webpack_public_path__ + "static/media/STEP-01.b603a342.png";